import ReactDOM from 'react-dom/client';

import MainComponent from '@/MainComponent';
import ThemeProvider from '@/app/contexts/ThemeProvider';
import { initializeTheme } from '@/app/contexts/theme';

import './reset.css';
import './tailwind.css';
import './fonts.css';

const root = document.getElementById('root')!;

initializeTheme();

ReactDOM.createRoot(root).render(
  <ThemeProvider>
    <MainComponent />
  </ThemeProvider>
);
